import { FormLayout, usePDFPrintHook } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import EditIcon from "../../Icons/EditIcon";
import { hasAccess } from "../../utils/permission";
import EditDeliveryCharge from "../EditDeliveryCharge";
import ComboboxInput from "../Reusable/ComboboxInput";
import InputCell from "../Reusable/DataTable/InputCell";
import NACell from "../Reusable/DataTable/NACell";
import TrackingCell from "../Reusable/DataTable/TrackingCell";
import DateRangePicker from "../Reusable/DateRangerPicker";
import InvoiceDataTable from "../Reusable/MerchantInvoiceDataTable";
import Modal from "../Reusable/Modal";
import CreateInvoiceForm from "./CreateInvoiceForm";
import moment from "moment";
import { getKey } from "../../helpers/sessionKey";
import CargoInvoicePopup from "./CargoInvoicePopup";
import MultiSelectFilterOrderStatus from "../Reusable/MultiSelectFilterOrderStatus";
import Button from "../Reusable/Button";
import usePostHook from "../../customHooks/usePostHook";
import { postApiData } from "../../helpers/AxiosInstance";
import EditConsignment from "../../pages/MerchantInvoice/EditConsignment";

const CreateMerchantInvoice = (props: any) => {
  const {
    handleCreate,
    isLoading,
    userPermissions,
    isDraftSaveLoading,
    handleSaveDraft,
    defaultBranch,
    isSuperUser,
  } = props;
  const [searchParams, setSearchParms] = useSearchParams();
  const [openCreateInvoicePopup, setOpenCreateInvoicePopup] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const checkedAllItems = searchParams.get("selectAllItems") === "1";
  const [invoiceReport, setInvoiceReport] = useState({
    totalCollectedCod: null,
    totalDeliverCharge: null,
    totalOrder: null,
    totalAmount: null,
  });
  const [data, setData] = useState([]);
  const [id, setId] = useState<string | undefined>();
  const [reportData, setReportData] = useState(null);
  const [chargevalue, setChargeValue] = useState();
  const [isReportDataLoading, setIsReportDataLoading] = useState(false);
  const [openDeliveryModal, setOpenDeliveryModal] = useState(false);
  console.log(id, "idddd");
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    watch,
    getValues,
    control,
    clearErrors,
  } = useForm<any>();

  const [user, setUser] = useState<any>("");

  const parseCombinedOrders = (searchParams) => {
    const editedRaw = searchParams.get("editedOrders");
    const selectedRaw = searchParams.get("selectedItems");

    const updatesMap = new Map();

    // --- 1. Parse selectedItems first ---
    if (selectedRaw) {
      selectedRaw.split(",").forEach((entry) => {
        const item = decodeItem(entry); // Use the new decodeItem

        // Initialize map entry
        if (!updatesMap.has(item.id)) {
          updatesMap.set(item.id, { id: item.id });
        }

        // Add fields from selectedItems
        updatesMap.get(item.id).delivery_charge = item.deliver_charge ?? 0;
        updatesMap.get(item.id).piece = item.piece ?? 0;
        updatesMap.get(item.id).weight = item.weight ?? 0;
      });
    }

    // --- 2. Parse editedOrders and overwrite selectedItems values ---
    if (editedRaw) {
      editedRaw.split(",").forEach((entry) => {
        // Format: id:field=value
        const [idField, value] = entry.split("=");
        const [id, field] = idField.split(":");

        // Ensure entry exists in the map
        if (!updatesMap.has(id)) {
          updatesMap.set(id, { id });
        }

        // Overwrite with editedOrders (takes priority)
        updatesMap.get(id)[field] = Number(value);
      });
    }

    return Array.from(updatesMap.values());
  };

  const handleGenerateReport = async () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder || selectedOrder.length === 0) {
      toast.error("Please select at least one order first");
      return;
    }
    setIsReportDataLoading(true);
    const dataToPost = parseCombinedOrders(searchParams);
    const url = `${APIS.MERCHANT_INVOICE}report/`;
    const formData = {
      orders: dataToPost,
    };
    try {
      const res = await postApiData({ url, formData, setError });
      if (res?.status === 200) {
        setReportData(res?.data);
        setOpenCreateInvoicePopup(!openCreateInvoicePopup);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsReportDataLoading(false);
    }
  };

  const encodeItem = (
    id: string,
    deliver_charge: number,
    piece: number,
    weight: number
  ) => {
    return `${id}%3Adelivery_charge%3D${deliver_charge ?? 0}%3Apiece%3D${
      piece ?? 0
    }%3Aweight%3D${weight ?? 0}`;
  };

  const decodeItem = (item: string) => {
    const parts = item.split("%3A");
    const id = parts[0];

    const fields: Record<string, number> = {};
    for (let i = 1; i < parts.length; i++) {
      const [key, value] = parts[i].split("%3D");
      fields[key] = Number(value);
    }

    return {
      id,
      deliver_charge: fields.delivery_charge ?? 0,
      piece: fields.piece ?? 0,
      weight: fields.weight ?? 0,
    };
  };

  const handleIndividualSelect = (
    value: string,
    deliver_charge: number,
    piece: number,
    weight: number
  ) => {
    let selectedItems = searchParams.get("selectedItems")?.split(",");

    if (!selectedItems || selectedItems[0] === "") {
      searchParams.set(
        "selectedItems",
        encodeItem(value, deliver_charge, piece, weight)
      );
      setSearchParms(searchParams);
      return;
    }

    let itemIndex = selectedItems.findIndex((item) => {
      const { id } = decodeItem(item);
      return id === value;
    });

    if (itemIndex > -1) {
      // Remove if already selected
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems.join(",");
      if (newSelectedItems.length) {
        searchParams.set("selectedItems", newSelectedItems);
      } else {
        searchParams.delete("selectedItems");
      }
      searchParams.set("selectAllItems", "0");
      setSearchParms(searchParams);
    } else {
      // Add new selection
      selectedItems.push(encodeItem(value, deliver_charge, piece, weight));
      const newSelectedItems = selectedItems.join(",");
      searchParams.set("selectedItems", newSelectedItems);
      setSearchParms(searchParams);
    }
  };

  const isSelected = (value: string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems) return false;

    return selectedItems.some((item) => decodeItem(item).id === value);
  };

  const handleSelectAll = (table: any) => {
    const {
      options: { data: tableData },
    } = table;
    const isSelected = searchParams.get("selectAllItems");

    if (isSelected === "1") {
      searchParams.set("selectAllItems", "0");
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } else {
      const selectedItems = tableData
        ?.map((item: any) =>
          encodeItem(item.id, item.deliver_charge, item.piece, item.weight)
        )
        .join(",");

      searchParams.set("selectAllItems", "1");
      searchParams.set("selectedItems", selectedItems);
      setSearchParms(searchParams);
    }
  };
  const domain = window.location.hostname;

  const handleNavigateNewTab = (value: string) => {
    window.open(`https://${domain}/order#/edit/${value}`, "_blank");
  };

  const handleEditPopup = (value: string) => {
    setIsOpen(true);
    setId(value);
  };

  const defaultColumns: any = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <div className={tw`flex justify-center w-full`}>
            <input
              type="checkbox"
              checked={checkedAllItems}
              onChange={() => handleSelectAll(table)}
              className={tw`cursor-pointer`}
            />
          </div>
        );
      },
      cell: ({ row }: any) => (
        <div className={tw`flex justify-center`}>
          <input
            type="checkbox"
            checked={isSelected(row?.original?.id)}
            onChange={() =>
              handleIndividualSelect(
                row?.original?.id,
                row?.original?.deliver_charge,
                row?.original?.total_piece,
                row?.original?.total_weight
              )
            }
            className={tw`cursor-pointer`}
          />
        </div>
      ),
    },
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: TrackingCell,
    },
    {
      header: "Origin",
      accessorKey: "pickup_branch.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.pickup_branch?.warehouse?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Sender",
      accessorKey: "sender.full_name",
      cell: NACell,
    },
    {
      header: "Receiver",
      accessorKey: "receiver.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw``}>
              {row?.original?.receiver.full_name ?? "N/A"}{" "}
            </p>
            <p className={tw`whitespace-nowrap text-sm`}>
              {row?.original?.receiver.primary_contact ?? "N/A"}{" "}
            </p>
            <p className={tw`text-sm`}>
              {row?.original?.receiver.address ?? "N/A"}{" "}
            </p>
          </>
        );
      },
    },
    {
      header: "Finance",
      accessorKey: "deliver_charge",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`whitespace-nowrap`}>
              COD: {row?.original?.cod ?? 0.0}{" "}
            </p>
            <p className={tw`whitespace-nowrap`}>
              Collected: {row?.original?.collected_cod ?? 0.0}
            </p>
          </>
        );
      },
    },
    {
      header: "Destination",
      accessorKey: "destination.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.destination_branch?.warehouse?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Product Type",
      accessorKey: "package_type.name",
      cell: ({ row, getValue }: any) => {
        return <p className={tw`capitalize`}> {getValue()}</p>;
      },
    },
    {
      header: "Service Type",
      accessorKey: "service_type.name",
      cell: ({ row, getValue }: any) => {
        return (
          <p className={tw`capitalize whitespace-nowrap`}> {getValue()}</p>
        );
      },
    },

    ...(hasAccess(["can_edit_invoice_piece"], userPermissions)
      ? [
          {
            header: "Piece",
            accessorKey: "total_piece",
            cell: ({ row, getValue, table, column }) => {
              return (
                <InputCell
                  row={row}
                  getValue={getValue}
                  searchParams={searchParams}
                  dataKey={"piece"}
                  setSearchParams={setSearchParms}
                  table={table}
                  column={column}
                />
              );
            },
            meta: {
              isEditable: true,
            },
          },
        ]
      : [
          {
            header: "Piece",
            accessorKey: "total_piece",
            cell: ({ row, getValue }: any) => {
              return (
                <>
                  <p
                    className={tw`cursor-pointer`}
                    onClick={(e) => {
                      handleEditPopup(row?.original?.id);
                      e.stopPropagation();
                    }}
                  >
                    {getValue() ?? 0}
                  </p>
                </>
              );
            },
          },
        ]),
    ...(hasAccess(["can_edit_invoice_weight"], userPermissions)
      ? [
          {
            header: "Weight(kg)",
            accessorKey: "total_weight",
            cell: ({ row, getValue, table, column }) => {
              return (
                <InputCell
                  row={row}
                  getValue={getValue}
                  searchParams={searchParams}
                  dataKey={"weight"}
                  setSearchParams={setSearchParms}
                  table={table}
                  column={column}
                />
              );
            },
            meta: {
              isEditable: true,
            },
          },
        ]
      : [
          {
            header: "Weight(kg)",
            accessorKey: "total_weight",
            cell: ({ row, getValue }: any) => {
              return (
                <>
                  <p
                    className={tw`cursor-pointer`}
                    onClick={(e) => {
                      handleEditPopup(row?.original?.id);
                      e.stopPropagation();
                    }}
                  >
                    {getValue() ?? 0}
                  </p>
                </>
              );
            },
          },
        ]),
    ...(hasAccess(["can_edit_invoice_delivery_charge"], userPermissions)
      ? [
          {
            header: "Delivery Charge",
            accessorKey: "deliver_charge",
            cell: ({ row, getValue, table, column }) => {
              return (
                <InputCell
                  row={row}
                  getValue={getValue}
                  searchParams={searchParams}
                  dataKey={"delivery_charge"}
                  setSearchParams={setSearchParms}
                  table={table}
                  column={column}
                />
              );
            },
            meta: {
              isEditable: true,
            },
          },
        ]
      : [
          {
            header: "Delivery Charge",
            accessorKey: "deliver_charge",
            cell: ({ row, getValue }: any) => {
              return (
                <>
                  <p
                    className={tw`cursor-pointer`}
                    onClick={(e) => {
                      handleEditPopup(row?.original?.id);
                      e.stopPropagation();
                    }}
                  >
                    {getValue() ?? 0}
                  </p>
                </>
              );
            },
          },
        ]),
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p
              className={tw`uppercase px-1 text-center rounded-md`}
              style={{ background: row?.original?.delivery_status?.color }}
            >
              {getValue()}
            </p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.rider?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => {
        return (
          <button
            className={tw`p-2 focus:outline-none`}
            onClick={() => handleNavigateNewTab(getValue())}
          >
            <EditIcon color={"var(--primary)"} />
          </button>
        );
      },
    },
  ];

  const defaultCargoColumns: any = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() =>
            handleIndividualSelect(
              row?.original?.id,
              row?.original?.deliver_charge,
              row?.original?.total_piece,
              row?.original?.total_weight
            )
          }
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: () => <p className={tw`w-full text-center`}>WAYBILL</p>,
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <div className={tw`cursor-pointer text-center focus:outline-none`}>
            <p className={tw`whitespace-nowrap`}>{getValue() ?? "N/A"}</p>
            <p className={tw`whitespace-nowrap`}>
              {moment(row?.original?.created).format("YY-MM-DD HH:mm:ss")}
            </p>{" "}
          </div>
        );
      },
    },
    {
      header: "Forwarding No.",
      accessorKey: "forwarding_no",
      cell: NACell,
    },
    {
      header: "Sender",
      accessorKey: "sender.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue()}</p>
            <p className={tw`text-[12px]`}>
              {row?.original?.sender?.primary_contact}
            </p>
          </>
        );
      },
    },
    {
      header: "Receiver",
      accessorKey: "receiver.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue()}</p>
            <p className={tw`text-[12px]`}>
              {row?.original?.receiver?.primary_contact}
            </p>
          </>
        );
      },
    },
    {
      header: "Country",
      accessorKey: "receiver.country",
      cell: NACell,
    },
    {
      header: "Piece",
      accessorKey: "total_piece",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Weight",
      accessorKey: "charge_wt",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Created By",
      accessorKey: "created_by",
      cell: NACell,
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p
              className={tw`uppercase px-1 text-center rounded-md`}
              style={{ background: row?.original?.delivery_status?.color }}
            >
              {getValue()}
            </p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.rider?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Total Amount",
      accessorKey: "total_amount",
      cell: ({ row, getValue, table, column }) => {
        return (
          <InputCell
            row={row}
            getValue={getValue}
            searchParams={searchParams}
            dataKey={"flat_amount"}
            setSearchParams={setSearchParms}
            table={table}
            column={column}
          />
        );
      },
      meta: {
        isEditable: true,
      },
    },
    {
      header: "Hub",
      accessorKey: "hub.name",
      cell: NACell,
    },
    {
      header: "P. Type",
      accessorKey: "reference_type.name",
      cell: NACell,
    },
  ];

  const handleActionMenu = () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    const editedRaw = searchParams.get("editedOrders");

    if (!selectedOrder || selectedOrder.length === 0) {
      toast.error("Please select at least one order first");
      return;
    }
    const editedMap: Record<
      string,
      Partial<{ delivery_charge: string; flat_amount: string }>
    > = {};
    if (editedRaw) {
      const edits = editedRaw.split(",");
      edits.forEach((entry) => {
        const [idPart, fieldPart] = entry.split(":");
        if (idPart && fieldPart) {
          const [field, value] = fieldPart.split("=");
          if (!editedMap[idPart]) {
            editedMap[idPart] = {};
          }
          editedMap[idPart][field] = value;
        }
      });
    }

    const selectedOrdersData = data.filter((order) =>
      selectedOrder.includes(order.id)
    );
    const totalOrder = selectedOrder?.length;
    const totalDeliveryCharge = selectedOrdersData.reduce((sum, order) => {
      const edited = editedMap[order.id];
      let deliveryCharge =
        edited?.delivery_charge ?? order?.deliver_charge ?? "0";
      deliveryCharge = parseFloat(deliveryCharge || 0);
      return sum + deliveryCharge;
    }, 0);

    const totalCollectedCOD = selectedOrdersData.reduce((sum, order) => {
      return sum + parseFloat(order?.collected_cod || "0");
    }, 0);
    const totalAmount = selectedOrdersData.reduce((sum, order) => {
      const edited = editedMap[order.id];
      let flatAmount = edited?.flat_amount ?? order?.total_amount ?? "0";
      flatAmount = parseFloat(flatAmount || 0);
      return sum + flatAmount;
    }, 0);

    setInvoiceReport({
      totalCollectedCod: totalCollectedCOD,
      totalDeliverCharge: totalDeliveryCharge,
      totalOrder: totalOrder,
      totalAmount: totalAmount,
    });
    setOpenCreateInvoicePopup(!openCreateInvoicePopup);
  };

  const handleRowClick = () => {};
  const filterParams = watch();

  useEffect(() => {
    if (user) {
      searchParams.delete("selectedItems");
      searchParams.delete("selectAllItems");
      setSearchParms(searchParams);
    }
  }, [user]);

  const clientType = getKey("client-type");
  const handleFormSubmit = () => {
    if (clientType === "cargo") {
      handleActionMenu();
    } else {
      handleGenerateReport();
    }
  };
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();

  const handlePrint = async () => {
    const rawSelected = searchParams.get("selectedItems")?.split(",");

    if (!rawSelected || rawSelected.length === 0 || rawSelected[0] === "") {
      toast.error("Please select at least one first");
      return;
    }
    const selectedOrderIds = rawSelected.map((item) => decodeItem(item).id);

    const url = `${APIS.ORDER}cod-print/`;
    let formData = {
      order_ids: selectedOrderIds,
    };
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleFormSubmit}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={isLoading || isReportDataLoading}
      >
        <div className={tw`mb-4 grid grid-cols-3 gap-2`}>
          <ComboboxInput
            url={APIS.MERCHANT}
            queryKey={"merchant"}
            register={register("vendor", {
              required: "Vendor Name is required",
            })}
            errors={errors?.vendor}
            name={"vendor"}
            label={"Select Vendor"}
            props={{
              is_active: true,
              ...(isSuperUser === "true"
                ? {}
                : { default_branch: defaultBranch?.id }),
            }}
            setValue={setValue}
            placeholder={"Select Vendor"}
            getValues={getValues}
            clearErrors={clearErrors}
            setUser={setUser}
          />
          <DateRangePicker
            label={"Select Date Range"}
            setValue={setValue}
            name={"created__range"}
            getValues={getValues}
          />
          <MultiSelectFilterOrderStatus
            label={"Payment Method"}
            queryKey={"payment-method"}
            params={{
              is_active: true,
            }}
            name={"payment_method__in"}
            placehoder="Select payment method..."
            control={control}
            url={`${APIS.PAYMENT_METHOD_TYPE}`}
          />
        </div>
      </FormLayout>
      {user ? (
        <InvoiceDataTable
          url={`${APIS.INVOICE_ORDER}`}
          queryKey={"orders"}
          columns={
            clientType === "cargo" ? defaultCargoColumns : defaultColumns
          }
          tableName={"invoice-orders"}
          isUpload={true}
          isDownload={true}
          setOrderData={setData}
          handleRowClick={handleRowClick}
          params={{
            ...filterParams,
            payment_method__in: filterParams?.payment_method__in
              ?.map((items) => items?.value)
              .join(","),
            invoice_id__isnull: true,
            is_create_invoice: true,
          }}
          actionMenu={
            <>
              <div className={tw`w-full flex justify-end`}>
                <div className={tw`w-24`}>
                  <Button
                    label={"Draft"}
                    isLoading={isDraftSaveLoading}
                    onClick={() => handleSaveDraft()}
                  />
                </div>
              </div>
              <div className={tw`w-full flex justify-end`}>
                <div className={tw`w-24`}>
                  <Button
                    label={"Print"}
                    isLoading={isPrintLoading}
                    onClick={() => handlePrint()}
                  />
                </div>
              </div>
            </>
          }
        />
      ) : null}
      <Modal
        isOpen={openCreateInvoicePopup}
        setIsOpen={setOpenCreateInvoicePopup}
        title={"Are You Sure You Want to Create Statement?"}
        children={
          <>
            {clientType === "cargo" ? (
              <CargoInvoicePopup
                handleCreate={handleCreate}
                setError={setError}
                isLoading={isLoading}
                user={user}
                invoiceReport={invoiceReport}
                getValues={getValues}
                setData={setData}
              />
            ) : (
              <CreateInvoiceForm
                handleCreate={handleCreate}
                setError={setError}
                isLoading={isLoading}
                user={user}
                invoiceReport={reportData}
                getValues={getValues}
                setData={setData}
              />
            )}
          </>
        }
      />
      <Modal
        title={"Update Delivery Charge"}
        isOpen={openDeliveryModal}
        setIsOpen={setOpenDeliveryModal}
        children={
          <>
            <div className={tw`w-[400px]`}>
              <EditDeliveryCharge
                id={id}
                openDeliveryModal={openDeliveryModal}
                setOpenDeliveryModal={setOpenDeliveryModal}
                chargevalue={chargevalue}
              />
            </div>
          </>
        }
      />

      {clientType == "logistic" && (
        <Modal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          title={"Edit Order"}
          children={
            <>
              <div className={tw``}>
                <EditConsignment id={id} />
              </div>
            </>
          }
        />
      )}
    </>
  );
};

export default CreateMerchantInvoice;
